/* Hilali Brass: reliable single-touch navigation, including momentum scrolling.
   Only the fixed four-link mobile bar is affected. */
(() => {
  const bar = document.querySelector('.hb-mobile-nav');
  if (!bar || !('ontouchstart' in window)) return;

  let gesture = null;
  let navigating = false;
  const maxMovement = 16;
  const maxDuration = 1200;

  bar.addEventListener('touchstart', (event) => {
    gesture = null;
    if (navigating || event.touches.length !== 1) return;
    const link = event.target.closest('a[href]');
    if (!link || !bar.contains(link)) return;
    const touch = event.changedTouches[0];
    gesture = {
      id: touch.identifier,
      link,
      x: touch.clientX,
      y: touch.clientY,
      began: performance.now()
    };
  }, { passive: true });

  bar.addEventListener('touchmove', (event) => {
    if (!gesture) return;
    const t = [...event.changedTouches].find(t => t.identifier === gesture.id);
    if (t && Math.hypot(t.clientX - gesture.x, t.clientY - gesture.y) > maxMovement) {
      gesture = null;
    }
  }, { passive: true });

  bar.addEventListener('touchcancel', () => {
    gesture = null;
  }, { passive: true });

  bar.addEventListener('touchend', (event) => {
    const start = gesture;
    gesture = null;
    if (!start || navigating || event.touches.length) return;
    const touch = [...event.changedTouches].find(t => t.identifier === start.id);
    if (!touch || performance.now() - start.began > maxDuration) return;
    if (Math.hypot(touch.clientX - start.x, touch.clientY - start.y) > maxMovement) return;

    const hit = document.elementFromPoint(touch.clientX, touch.clientY);
    if (!hit || !start.link.contains(hit)) return;

    // Mobile Safari can consume the native first click to stop kinetic scrolling.
    // Activate on the completed tap instead; never on touchstart or a swipe.
    if (event.cancelable) event.preventDefault();
    navigating = true;
    window.location.assign(start.link.href);
  }, { passive: false });
})();